// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__3468o","title":"styles_title__3Ule4"};